import { render } from "./ContactForm.vue?vue&type=template&id=5083c888"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/sections/modules/ContactForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5083c888"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5083c888', __exports__)) {
    api.reload('5083c888', __exports__)
  }
  
  module.hot.accept("./ContactForm.vue?vue&type=template&id=5083c888", () => {
    api.rerender('5083c888', render)
  })

}


export default __exports__